const ITEMS = [
  "STAGE 1–3 REMAPS",
  "DYNO-PROVEN GAINS",
  "+35% AVERAGE BHP",
  "CUSTOM ECU SOFTWARE",
  "EGR · ADBLUE · DPF SOLUTIONS",
  "ECO & ECONOMY MAPS",
  "SPEED LIMITER REMOVAL",
  "1-YEAR MAP WARRANTY",
];

export const Marquee = () => {
  const strip = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-[#1F232D] bg-panel/60 py-5 select-none"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {strip.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-heading font-semibold uppercase tracking-[0.2em] text-xl sm:text-2xl text-neutral-500">
              {item}
            </span>
            <span className="inline-block w-2 h-2 rotate-45 bg-nitro shadow-[0_0_10px_rgba(255,46,77,0.7)]" />
          </span>
        ))}
      </div>
    </div>
  );
};
